import { a as azureDevOpsApiRef, A as AzureDevOpsClient, b as azurePullRequestDashboardRouteRef, c as azurePipelinesEntityContentRouteRef, d as azureGitTagsEntityContentRouteRef, e as azurePullRequestsEntityContentRouteRef } from './esm/AzureDevOpsApi-GBxs-uQ7.esm.js';
import { createPlugin, createApiFactory, discoveryApiRef, fetchApiRef, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import { AZURE_DEVOPS_REPO_ANNOTATION, AZURE_DEVOPS_PROJECT_ANNOTATION, AZURE_DEVOPS_BUILD_DEFINITION_ANNOTATION } from '@backstage-community/plugin-azure-devops-common';
export { A as AzurePullRequestsIcon } from './esm/AzurePullRequestsIcon-DOAkj-X3.esm.js';
export { F as FilterType } from './esm/PullRequestsPage-CkhRQsgx.esm.js';
import 'luxon';
import 'humanize-duration';
import '@backstage/errors';
import 'react';
import '@material-ui/core/SvgIcon';
import '@backstage/core-components';
import '@material-ui/core/Paper';
import '@material-ui/core/Typography';
import '@material-ui/core/styles';
import '@material-ui/core/Card';
import '@material-ui/core/CardContent';
import '@material-ui/core/CardHeader';
import '@material-ui/icons/DoneAll';
import '@material-ui/icons/Cancel';
import '@material-ui/icons/GroupWork';
import '@material-ui/icons/WatchLater';
import 'react-use/esm/useAsync';
import 'react-use/esm/useAsyncRetry';
import 'react-use/esm/useInterval';
import '@backstage/catalog-model';
import '@backstage/plugin-permission-react';

const isAzureDevOpsAvailable = (entity) => {
  var _a;
  return Boolean((_a = entity.metadata.annotations) == null ? void 0 : _a[AZURE_DEVOPS_REPO_ANNOTATION]);
};
const isAzurePipelinesAvailable = (entity) => {
  var _a, _b, _c;
  return Boolean((_a = entity.metadata.annotations) == null ? void 0 : _a[AZURE_DEVOPS_REPO_ANNOTATION]) || Boolean((_b = entity.metadata.annotations) == null ? void 0 : _b[AZURE_DEVOPS_PROJECT_ANNOTATION]) && Boolean(
    (_c = entity.metadata.annotations) == null ? void 0 : _c[AZURE_DEVOPS_BUILD_DEFINITION_ANNOTATION]
  );
};
const azureDevOpsPlugin = createPlugin({
  id: "azureDevOps",
  apis: [
    createApiFactory({
      api: azureDevOpsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef
      },
      factory: ({ discoveryApi, fetchApi }) => new AzureDevOpsClient({ discoveryApi, fetchApi })
    })
  ]
});
const AzurePullRequestsPage = azureDevOpsPlugin.provide(
  createRoutableExtension({
    name: "AzurePullRequestsPage",
    component: () => import('./esm/index-W1pvc5vi.esm.js').then((m) => m.PullRequestsPage),
    mountPoint: azurePullRequestDashboardRouteRef
  })
);
const EntityAzurePipelinesContent = azureDevOpsPlugin.provide(
  createRoutableExtension({
    name: "EntityAzurePipelinesContent",
    component: () => import('./esm/index-Bwu2-Sgs.esm.js').then(
      (m) => m.EntityPageAzurePipelines
    ),
    mountPoint: azurePipelinesEntityContentRouteRef
  })
);
const EntityAzureGitTagsContent = azureDevOpsPlugin.provide(
  createRoutableExtension({
    name: "EntityAzureGitTagsContent",
    component: () => import('./esm/index-1Rl7C23d.esm.js').then(
      (m) => m.EntityPageAzureGitTags
    ),
    mountPoint: azureGitTagsEntityContentRouteRef
  })
);
const EntityAzurePullRequestsContent = azureDevOpsPlugin.provide(
  createRoutableExtension({
    name: "EntityAzurePullRequestsContent",
    component: () => import('./esm/index-Bo-6jkQA.esm.js').then(
      (m) => m.EntityPageAzurePullRequests
    ),
    mountPoint: azurePullRequestsEntityContentRouteRef
  })
);
const EntityAzureReadmeCard = azureDevOpsPlugin.provide(
  createComponentExtension({
    name: "EntityAzureReadmeCard",
    component: {
      lazy: () => import('./esm/index-BJ_pWnMh.esm.js').then((m) => m.ReadmeCard)
    }
  })
);

export { AzureDevOpsClient, AzurePullRequestsPage, EntityAzureGitTagsContent, EntityAzurePipelinesContent, EntityAzurePullRequestsContent, EntityAzureReadmeCard, azureDevOpsApiRef, azureDevOpsPlugin, isAzureDevOpsAvailable, isAzurePipelinesAvailable };
//# sourceMappingURL=index.esm.js.map
